import React, { useEffect } from "react";
import DrawerCustom from "../../../../shared/general/Drawer";
import { useDispatch, useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  MenuItem,
  Typography,
  createFilterOptions,
  styled,
} from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import ButtonBlue from "../../../../shared/general/ButtonBlue";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import {
  addManagerGroup,
  getManagerGroup,
  updateManagerGroup,
} from "../../../../../../actions/manager";

const StyledRoot = styled(Box)({
  padding: "16px",
  "& .MuiAutocomplete-root": {
    "& .MuiOutlinedInput-root": {
      padding: "13.5px 14px",
      paddingRight: "32px",
      "& input": {
        padding: 0,
      },
    },
  },
  "& .field-label": {
    paddingBottom: "4px",
    fontWeight: "500",
    fontSize: "14px",
  },
});

const DrawerManagerGroup = (props) => {
  const dispatch = useDispatch();

  const { company, drawerConfig, onClose } = props;

  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: managerList } = useSelector((state) => state.manager);

  const filterOptions = createFilterOptions({
    stringify: (value) =>
      `${value.firstname_TH} ${value.lastname_TH} ${value.email}`,
  });

  const validateYupSchema = yup.object({
    managerGroupName: yup.string().required("กรุณากรอกข้อมูล"),
    managerList: yup.array().of(
      yup.object().shape({
        idManager: yup.string().required("กรุณากรอกข้อมูล"),
      })
    ),
  });

  const useHookForm = useForm({
    defaultValues: {
      managerGroupName: "",
      managerList: [],
    },
    resolver: yupResolver(validateYupSchema),
    mode: "all",
  });

  const useFieldArrayManagerList = useFieldArray({
    control: useHookForm.control,
    name: "managerList",
  });

  useEffect(() => {
    if (drawerConfig.isOpen === true) {
      if (drawerConfig.isEdit) {
        useHookForm.reset({
          managerGroupName: drawerConfig.data.managerGroupName || "",
          managerList: drawerConfig.data.managerList
            ? drawerConfig.data.managerList.map((item) => ({
                idManager: item.idManager,
              }))
            : [],
        });
      } else {
        useHookForm.reset({
          managerGroupName: "",
          managerList: [],
        });
      }
    }
  }, [drawerConfig.isOpen]);

  const onSubmit = async (data) => {
    // console.log(data)

    let result = null;

    const formData = {
      ...data,
      // idEmployees: employeeProfile.idEmployees,
    };

    if (!drawerConfig.isEdit) {
      formData.idCompany = company.idCompany;
      result = await dispatch(addManagerGroup(formData));
    } else {
      result = await dispatch(
        updateManagerGroup(drawerConfig.data.idManagerGroup, formData)
      );
    }

    if (result) {
      if (result.status === 200) {
        // setAlertConfig(prev => ({
        //   ...prev,
        //   isOpen: true,
        //   type: "success",
        //   message: "บันทึกข้อมูลสำเร็จ"
        // }))
        // dispatch(getEmployeeProfile(employeeProfile.idEmployees, true));
        dispatch(getManagerGroup(company.idCompany));
        onClose();
      } else {
        // setAlertConfig(prev => ({
        //   ...prev,
        //   isOpen: true,
        //   type: "error",
        //   message: "เกิดข้อผิดพลาด กรุณาติดต่อผู้ดูแล"
        // }))
      }
    } else {
      // setAlertConfig(prev => ({
      //   ...prev,
      //   isOpen: true,
      //   type: "error",
      //   message: "เกิดข้อผิดพลาด กรุณาติดต่อผู้ดูแล"
      // }))
    }
  };

  return (
    <DrawerCustom
      title={
        drawerConfig.isEdit ? "แก้ไขกลุ่มหัวหน้างาน" : "เพิ่มกลุ่มหัวหน้างาน"
      }
      anchor="right"
      open={drawerConfig.isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <StyledRoot>
        <form onSubmit={useHookForm.handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className="field-label">
                ชื่อกลุ่มหัวหน้างาน
              </Typography>
              <Controller
                name="managerGroupName"
                control={useHookForm.control}
                render={({ field }) => (
                  <TextFieldTheme
                    {...field}
                    helperText={
                      useHookForm.formState.errors[field.name]
                        ? useHookForm.formState.errors[field.name].message
                        : null
                    }
                    error={
                      useHookForm.formState.errors[field.name] ? true : false
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize="18px" fontWeight="500">
                รายชื่อหัวหน้างานในกลุ่ม
              </Typography>
            </Grid>

            {useFieldArrayManagerList.fields.map((item, index) => (
              <Grid key={item.id} item xs={12}>
                <Box display="flex" alignItems="center" paddingBottom="4px">
                  <Typography flexGrow="1" fontSize="14px" fontWeight="500">
                    หัวหน้าคนที่ {index + 1}
                  </Typography>
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      useFieldArrayManagerList.remove(index);
                    }}
                  >
                    <DeleteOutlineRoundedIcon fontSize="inherit" />
                  </IconButton>
                </Box>
                <Controller
                  name={`managerList.${index}.idManager`}
                  control={useHookForm.control}
                  render={({ field }) => (
                    <Autocomplete
                      options={managerList ? managerList : []}
                      getOptionLabel={(option) => `${option.name}`}
                      filterOptions={filterOptions}
                      noOptionsText="ไม่พบข้อมูล"
                      renderOption={(props, option) => (
                        <MenuItem {...props} key={option.idManagerEmployee}>
                          <Box>
                            <Typography>{option.name}</Typography>
                            <Typography color="text.third" fontSize="14px">
                              ตำแหน่ง: {option.positionsName}
                            </Typography>
                            <Typography color="text.third" fontSize="14px">
                              อีเมล: {option.email}
                            </Typography>
                          </Box>
                        </MenuItem>
                      )}
                      renderInput={(params) => (
                        <TextFieldTheme
                          {...params}
                          onBlur={field.onBlur}
                          error={
                            useHookForm.formState.errors["managerList"] &&
                            useHookForm.formState.errors["managerList"][
                              index
                            ] &&
                            useHookForm.formState.errors["managerList"][index][
                              "idManager"
                            ]
                              ? true
                              : false
                          }
                          helperText={
                            useHookForm.formState.errors["managerList"] &&
                            useHookForm.formState.errors["managerList"][
                              index
                            ] &&
                            useHookForm.formState.errors["managerList"][index][
                              "idManager"
                            ]
                              ? useHookForm.formState.errors["managerList"][
                                  index
                                ]["idManager"].message
                              : null
                          }
                        />
                      )}
                      value={
                        managerList
                          ? managerList.find(
                              (option) =>
                                option.idManagerEmployee === field.value
                            ) || null
                          : null
                      }
                      onChange={(_, value) => {
                        field.onChange(value ? value.idManagerEmployee : "");
                      }}
                      disableClearable
                    />
                  )}
                />
              </Grid>
            ))}

            <Grid item xs={12}>
              <ButtonBlue
                variant="outlined"
                startIcon={<AddIcon />}
                fullWidth
                onClick={() => {
                  useFieldArrayManagerList.append({
                    idManager: "",
                  });
                }}
              >
                เพิ่มรายชื่อหัวหน้างาน
              </ButtonBlue>
            </Grid>

            <Grid item xs={12} container justifyContent="space-between">
              <ButtonBlue
                variant="text"
                onClick={onClose}
                disabled={useHookForm.formState.isSubmitting}
              >
                ยกเลิก
              </ButtonBlue>
              <ButtonBlue
                variant="contained"
                type="submit"
                disabled={useHookForm.formState.isSubmitting}
              >
                บันทึกข้อมูล
              </ButtonBlue>
            </Grid>
          </Grid>
        </form>
      </StyledRoot>
    </DrawerCustom>
  );
};

export default DrawerManagerGroup;
